export default __webpack_public_path__ + "static/media/mons8.2ba8c276.jpg";